import { MAXIMUM_PROGRESS_VALUE, MINIMUM_PROGRESS_VALUE, ProgressActionType, PROGRESSES_INITIAL_STATE } from './const';
import { ProgressesReducerAction, ProgressItem } from './types';
import { isUndefined } from '../../predicates/type';

export const progressesReducer = (state: ProgressItem[], action: ProgressesReducerAction): ProgressItem[] => {
	switch (action.type) {
		case ProgressActionType.AddProgress:
			return [
				...state,
				{
					id: action.payload.id,
					value: MINIMUM_PROGRESS_VALUE,
					isActive: false,
				},
			];
		case ProgressActionType.MakeProgressActive:
			return state.map((progress) => {
				if (progress.id === action.payload.id) {
					return {
						...progress,
						isActive: true,
					};
				}

				return progress;
			});
		case ProgressActionType.RemoveProgress:
			return [...state].filter((progress) => progress.id !== action.payload.id);
		case ProgressActionType.SetProgressValue:
			if (action.payload.value > MAXIMUM_PROGRESS_VALUE) {
				return state;
			}

			const targetProgress = state.find((progress) => progress.id === action.payload.id);

			if (isUndefined(targetProgress)) {
				return state;
			}

			const targetProgressIndex = state.indexOf(targetProgress);
			const newState = [...state];
			newState[targetProgressIndex] = {
				id: action.payload.id,
				value: action.payload.value,
				isActive: targetProgress.isActive,
			};

			return newState;
		case ProgressActionType.SetAllProgressValues:
			if (action.payload.value > MAXIMUM_PROGRESS_VALUE) {
				return state;
			}

			return state.map((progress) => ({
				id: progress.id,
				value: action.payload.value,
				isActive: progress.isActive,
			}));
		case ProgressActionType.RemoveAllProgresses:
		default:
			return PROGRESSES_INITIAL_STATE;
	}
};
